import useCart from '@context/useCartContext'
import type { AddItemParams } from './add-item'
import addItem from './add-item'

/**
 * A hook to add cart items and revalidate cart's data
 */
export default function useAddItem() {
	const { revalidate } = useCart()

	const addItemAndRevalidateCart = async ({
		variantId,
		quantity,
		sellingPlanId,
		attributes
	}: AddItemParams) => {
		await addItem({ variantId, quantity, sellingPlanId, attributes })

		await revalidate()
	}

	return addItemAndRevalidateCart
}
